<template>
  <div class="ws-after-sales-detail">
    <div class="page-header">
      <div class="back-btn" @click="goBack">{{ $t('wholesaler.AfterSalesDetail.line4_text') }}</div>
      <h1>{{ $t('wholesaler.AfterSalesDetail.line5_text') }}</h1>
      <div class="sub">{{ detail.afterSalesNo }}</div>
    </div>

    <div v-loading="loading" class="content">
      <!-- 客户申请信息 -->
      <div class="module">
        <div class="module-header"><span class="icon">📝</span><span class="title">{{ $t('wholesaler.AfterSalesDetail.line12_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line14_text') }}</span><span class="value mono">{{ detail.afterSalesNo }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line15_text') }}</span><span class="value">{{ detail.customerName || '-' }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line16_text') }}</span><span class="value mono" @click="goOrder" style="color:#457b9d;cursor:pointer;">{{ detail.orderNo }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line17_text') }}</span><span class="value">{{ reasonText(detail.reasonCode) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line18_text') }}</span><span class="value" style="text-align:right;">{{ detail.reasonText }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line19_text') }}</span><span class="value">{{ detail.customerExpect || '-' }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line20_text') }}</span><span class="value">{{ detail.requestedAt }}</span></div>
        </div>
      </div>

      <!-- 凭证图片 -->
      <div v-if="detail.evidenceUrls" class="module">
        <div class="module-header"><span class="icon">📸</span><span class="title">{{ $t('wholesaler.AfterSalesDetail.line26_text') }}</span></div>
        <div class="module-body">
          <div class="evidence-grid">
            <el-image v-for="(url, i) in evidenceList" :key="i" :src="getImageUrl(url)" :preview-src-list="evidenceList" class="evidence-img" fit="cover"></el-image>
          </div>
        </div>
      </div>

      <!-- 状态进度条 -->
      <div v-if="detail.status !== 'PENDING_REVIEW'" class="module">
        <div class="module-header"><span class="icon">📊</span><span class="title">{{ $t('wholesaler.AfterSalesDetail.line36_text') }}</span></div>
        <div class="module-body">
          <div class="progress-bar">
            <div class="progress-step" v-for="(step, i) in progressSteps" :key="i" :class="stepClass(i)">
              <div class="progress-dot">{{ step.icon }}</div>
              <div class="progress-label">{{ step.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 处理方案 -->
      <div v-if="detail.resolutionType" class="module" style="border:2px solid #1890ff;">
        <div class="module-header" style="background:#e6f7ff;color:#1890ff;"><span class="icon">✏️</span><span class="title">{{ $t('wholesaler.AfterSalesDetail.line49_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line51_text') }}</span><span class="value" style="color:#1890ff;font-weight:500;">{{ schemeText(detail.resolutionType) }}</span></div>
          <div class="row" style="flex-direction:column;align-items:flex-start;">
            <span class="label" style="margin-bottom:6px;">{{ $t('wholesaler.AfterSalesDetail.line53_text') }}</span>
            <span class="value" style="text-align:left;width:100%;">
              <span v-for="(item, idx) in applyItemsList" :key="idx" class="product-tag">
                {{ item.productName }} × {{ item.quantity }}
              </span>
            </span>
          </div>
          <div v-if="detail.resolutionType !== 'RETURN_REFUND'" class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line60_text') }}</span><span class="value">{{ returnMethodText(detail.returnMethod) }}</span></div>
          <div v-if="detail.resolutionType !== 'RETURN_REFUND'" class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line61_text') }}</span><span class="value">{{ detail.returnWarehouseName || '-' }}</span></div>
          <div class="row" v-if="detail.resendWarehouseName"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line62_text') }}</span><span class="value">{{ detail.resendWarehouseName }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line63_text') }}</span><span class="value">{{ detail.reviewNote || '-' }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line64_text') }}</span><span class="value">{{ detail.reviewedAt }}</span></div>
          <div v-if="detail.refundAmount > 0" style="margin-top:12px;padding-top:12px;border-top:2px solid #f0f0f0;">
            <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line66_text') }}</span><span class="value">S$ {{ centsToAmount(detail.itemRefundAmount) }}</span></div>
            <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line67_text') }}</span><span class="value">S$ {{ centsToAmount(detail.gstRefundAmount) }}</span></div>
            <div class="row" style="padding-top:8px;border-top:1px dashed #e8e8e8;"><span class="label" style="font-weight:600;">{{ $t('wholesaler.AfterSalesDetail.line68_text') }}</span><span class="value amount">S$ {{ centsToAmount(detail.refundAmount) }}</span></div>
          </div>
        </div>
      </div>

      <!-- ⭐ 配送任务模块（换货/补发） -->
      <div v-if="detail.resolutionType === 'EXCHANGE' || detail.resolutionType === 'RESEND'" class="module" style="border:2px solid #722ed1;">
        <div class="module-header" style="background:#f9f0ff;color:#722ed1;"><span class="icon">🚚</span><span class="title">{{ $t('wholesaler.AfterSalesDetail.line75_text') }}</span></div>
        <div class="module-body">
          <!-- 无任务：显示创建按钮 -->
          <div v-if="!deliveryTask">
            <el-button type="primary" size="large" @click="showCreateTaskDialog" style="width:100%;height:44px;font-size:14px;">
              📋 创建配送任务
            </el-button>
          </div>
          <!-- 有任务：显示任务卡片 -->
          <div v-else>
            <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line85_text') }}</span><span class="value mono">{{ deliveryTask.taskNo }}</span></div>
            <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line86_text') }}</span><span class="value">{{ deliveryTask.driverName || '-' }}</span></div>
            <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line87_text') }}</span><span class="value">{{ deliveryTask.pickupContact || '-' }}</span></div>
            <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line88_text') }}</span><span class="value"><el-tag :type="deliveryTaskStatusType(deliveryTask.status)" size="small">{{ deliveryTaskStatusText(deliveryTask.status) }}</el-tag></span></div>
            <div v-if="deliveryTask.exchangeItems" style="margin-top:8px;padding-top:8px;border-top:1px dashed #f0f0f0;">
              <div style="font-size:12px;color:#999;margin-bottom:4px;">{{ $t('wholesaler.AfterSalesDetail.line90_text') }}</div>
              <span v-for="(item, idx) in parseExchangeItems(deliveryTask.exchangeItems)" :key="idx" class="product-tag">{{ item.productName || item.productCode || '商品' }} × {{ item.quantity }}</span>
            </div>
            <div class="row" style="margin-top:8px;"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line93_text') }}</span><span class="value" style="font-size:11px;">{{ deliveryTask.createdAt }}</span></div>
            <div v-if="deliveryTask.pickedUpAt" class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line94_text') }}</span><span class="value" style="font-size:11px;">{{ deliveryTask.pickedUpAt }}</span></div>
            <div v-if="deliveryTask.completedAt" class="row"><span class="label">{{ $t('wholesaler.AfterSalesDetail.line95_text') }}</span><span class="value" style="font-size:11px;">{{ deliveryTask.completedAt }}</span></div>
          </div>
        </div>
      </div>

      <!-- ⭐ 创建配送任务弹窗 -->
      <el-dialog :title="$t('wholesaler.AfterSalesDetail.line101_title')" :visible.sync="createTaskVisible" width="500px" :close-on-click-modal="false">
        <el-form :model="createTaskForm" label-width="80px" size="small">
          <el-form-item label="售后单号">
            <span class="mono">{{ detail.afterSalesNo }}</span>
          </el-form-item>
          <el-form-item label="处理方案">
            <span>{{ schemeText(detail.resolutionType) }}</span>
          </el-form-item>
          <el-form-item label="仓库" required>
            <el-select v-model="createTaskForm.warehouseId" :placeholder="$t('wholesaler.AfterSalesDetail.line110_placeholder')" style="width:100%;">
              <el-option v-for="w in warehouses" :key="w.id" :label="w.warehouseName + (w.isDefault ? ' (默认)' : '')" :value="w.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="配送员" required>
            <el-select v-model="createTaskForm.driverId" :placeholder="$t('wholesaler.AfterSalesDetail.line115_placeholder')" style="width:100%;">
              <el-option v-for="d in drivers" :key="d.id" :label="d.driverName" :value="d.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="createTaskForm.remark" type="textarea" :rows="2" :placeholder="$t('wholesaler.AfterSalesDetail.line120_placeholder')" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="createTaskVisible = false">{{ $t('common.cancel') }}</el-button>
          <el-button type="primary" :loading="creating" @click="submitCreateTask">{{ $t('wholesaler.AfterSalesDetail.line125_text') }}</el-button>
        </div>
      </el-dialog>

      <!-- ⭐ 动态操作按钮 -->
      <div v-if="actionButtons.length > 0" class="module" style="border:2px solid #fa8c16;">
        <div class="module-body" style="padding:16px;">
          <div v-for="(btn, idx) in actionButtons" :key="idx">
            <el-button
              :type="btn.type || 'default'"
              :style="{ width: '100%', height: '44px', fontSize: '14px', marginTop: idx > 0 ? '8px' : '0' }"
              @click="btn.action"
            >
              {{ btn.label }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 操作日志 -->
      <div class="module">
        <div class="module-header"><span class="icon">📝</span><span class="title">{{ $t('wholesaler.AfterSalesDetail.line146_text') }}</span></div>
        <div class="module-body">
          <div v-if="actions.length > 0">
            <div class="log-item" v-for="log in actions" :key="log.id">
              <div class="log-dot"></div>
              <div class="log-content">
                <div class="log-title">{{ log.actionType }}</div>
                <div class="log-note" v-if="log.note">{{ log.note }}</div>
                <div class="log-time">{{ log.createdAt }}</div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state"><div class="empty-icon">📄</div><div class="empty-text">{{ $t('wholesaler.AfterSalesDetail.line158_text') }}</div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { getImageUrl } from '@/utils/image';
import { getAfterSalesDetail, getAfterSalesActions, getRefundReceipt, executeRefund,
  createAfterSalesDeliveryTask, getAfterSalesDeliveryTask, getAvailableDrivers, getAvailableWarehouses } from '@/services/afterSales';

export default {
  name: 'WholesalerAfterSalesDetail',
  data() {
    return {
      loading: false, detail: {}, actions: [],
      deliveryTask: null,
      createTaskVisible: false,
      creating: false,
      warehouses: [],
      drivers: [],
      createTaskForm: { warehouseId: null, driverId: null, remark: '' }
    };
  },
  computed: {
    evidenceList() {
      try { return this.detail.evidenceUrls ? JSON.parse(this.detail.evidenceUrls) : []; }
      catch { return []; }
    },
    applyItemsList() {
      try {
        const items = this.detail.applyItems ? JSON.parse(this.detail.applyItems) : [];
        return items.map(item => ({ productName: item.productName, quantity: item.quantity }));
      } catch { return []; }
    },
    // ⭐ 动态操作按钮
    actionButtons() {
      const { status, resolutionStatus, resolutionType } = this.detail;
      if (status === 'REJECTED' || status === 'CANCELLED' || resolutionStatus === 'COMPLETED') return [];

      // 待审核
      if (status === 'PENDING_REVIEW') {
        return [{ label: '✏️ 审核售后', type: 'primary', action: this.goReview }];
      }

      // 根据 resolutionStatus 返回对应按钮
      const btns = [];
      switch (resolutionStatus) {
        case 'PICKING_UP':
          btns.push({ label: '🚚 取件确认', type: 'warning', action: this.goPickup });
          break;
        case 'RETURN_RECEIVED':
        case 'INSPECTING':
        case 'AWAITING_RETURN':
          btns.push({ label: '🔧 处理退货', type: 'warning', action: this.goReturn });
          break;
        case 'REFUND_PROCESSING':
          btns.push({ label: '💰 确认退款', type: 'danger', action: this.goRefund });
          break;
        case 'EXCHANGE_SHIPPING':
        case 'RESEND_SHIPPING':
          // 检查是否已有配送任务
          if (this.detail.pickupTaskId) {
            btns.push({ label: '🚚 查看配送进度', type: 'info', action: this.viewTask });
          } else {
            btns.push({ label: '📋 创建配送任务', type: 'primary', action: this.showCreateTaskDialog });
          }
          break;
        case 'EXCHANGE_DELIVERED':
        case 'RESEND_DELIVERED':
          btns.push({ label: '📮 发货确认', type: 'primary', action: this.goShipping });
          break;
        case 'INSPECTION_FAILED':
          btns.push({ label: '⚠️ 异常处理', type: 'warning', action: this.goInspectionFailed });
          break;
      }

      // 通用按钮
      btns.push({ label: '🖨️ 打印退单小票', action: this.printReceipt });
      return btns;
    },
    progressSteps() {
      const type = this.detail.resolutionType;
      const steps = [
        { icon: '1', label: '待审核' },
        { icon: '2', label: '已审核' }
      ];
      if (['RETURN_REFUND', 'EXCHANGE'].includes(type)) {
        if (type === 'RETURN_REFUND') {
          // ⭐ 简化流程：退货退款不再显示取件步骤
          steps.push({ icon: '3', label: '处理' });
        } else {
          steps.push({ icon: '3', label: '取件' }, { icon: '4', label: '质检' });
        }
      }
      if (type === 'RETURN_REFUND' || type === 'PARTIAL_REFUND' || type === 'RELIEF') {
        steps.push({ icon: '5', label: '退款' });
      }
      if (type === 'EXCHANGE' || type === 'RESEND') {
        steps.push({ icon: '5', label: '发货' });
      }
      steps.push({ icon: '✓', label: '完成' });
      return steps;
    }
  },
  created() { this.loadDetail(); },
  methods: {
    getImageUrl,
    stepClass(i) {
      const status = this.detail.resolutionStatus;
      const stepMap = {
        PENDING_REVIEW: 0, REVIEWED: 1, PICKING_UP: 2,
        RETURN_RECEIVED: 3, INSPECTING: 3, INSPECTION_FAILED: 3,
        AWAITING_RETURN: 3,  // ⭐ 简化流程
        REFUND_PROCESSING: this.detail.resolutionType === 'EXCHANGE' ? 4 : 4,
        EXCHANGE_SHIPPING: 4, RESEND_SHIPPING: 4,
        EXCHANGE_DELIVERED: 5, RESEND_DELIVERED: 5,
        REFUND_COMPLETED: 5, COMPLETED: 5
      };
      const current = stepMap[status] || 0;
      if (i < current) return 'done';
      if (i === current) return 'active';
      return '';
    },
    goReview() { this.$router.push(`/wholesaler/after-sales/${this.detail.id}/review`); },
    goPickup() { this.$router.push(`/wholesaler/after-sales/${this.detail.id}/pickup`); },
    goReturn() { this.$router.push(`/wholesaler/after-sales/${this.detail.id}/return`); },
    goRefund() { this.$router.push(`/wholesaler/after-sales/${this.detail.id}/refund`); },
    goShipping() { this.$router.push(`/wholesaler/after-sales/${this.detail.id}/shipping`); },
    goInspectionFailed() { this.$router.push(`/wholesaler/after-sales/${this.detail.id}/inspection-failed`); },
    goOrder() { if (this.detail.orderId) this.$router.push(`/wholesaler/orders/${this.detail.orderId}`); },
    reasonText(code) { const m = { DAMAGED:'商品破损', WRONG_ITEM:'发错货了', NOT_RECEIVED:'没收到货', WRONG_SPEC:'规格不对', SHORT_DELIVERY:'少发了', DONT_WANT:'不想要了', OTHER:'其他' }; return m[code] || code; },
    schemeText(type) { if (!type) return '-'; const m = { RETURN_REFUND:'退货退款', EXCHANGE:'换货', RESEND:'补发', PARTIAL_REFUND:'部分退款', RELIEF:'减免', NO_ACTION:'不处理' }; return m[type] || type; },
    returnMethodText(m) { if (!m) return '-'; const map = { COURIER_PICKUP:'配送员取件', SELF_SEND:'客户自寄' }; return map[m] || m; },
    centsToAmount(c) { if (!c) return '0.00'; return (c / 100).toFixed(2); },
    async printReceipt() {
      try {
        const res = await getRefundReceipt(this.detail.id);
        if (res && res.receipt) {
          // 推送到易联云打印
          await api.post(`/wholesaler/printer/print-after-sales/${this.detail.id}`);
          this.$message.success('退单小票已推送打印');
        } else {
          this.$message.warning('退单小票内容为空');
        }
      } catch (e) {
        this.$message.error('打印失败: ' + (e.response?.data?.message || e.message));
      }
    },
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        this.detail = await getAfterSalesDetail(id);
        this.actions = await getAfterSalesActions(id);
        // 加载配送任务
        if (this.detail.pickupTaskId) {
          try {
            const res = await getAfterSalesDeliveryTask(id);
            this.deliveryTask = res;
          } catch (e) { /* ignore */ }
        } else {
          this.deliveryTask = null;
        }
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || e));
      } finally { this.loading = false; }
    },
    goBack() { this.$router.back(); },

    // ===== 配送任务相关 =====
    deliveryTaskStatusType(status) {
      const map = { PENDING: 'warning', DELIVERING: 'success', COMPLETED: 'info', CANCELLED: 'danger' };
      return map[status] || 'info';
    },
    deliveryTaskStatusText(status) {
      const map = { PENDING: '🔵 待取货', DELIVERING: '🟡 配送中', COMPLETED: '🟢 已完成', CANCELLED: '已取消' };
      return map[status] || status;
    },
    parseExchangeItems(json) {
      try { return JSON.parse(json) || []; } catch { return []; }
    },
    async showCreateTaskDialog() {
      this.createTaskVisible = true;
      this.createTaskForm = { warehouseId: null, driverId: null, remark: '' };
      // 加载仓库和配送员列表
      try {
        const [whRes, drvRes] = await Promise.all([
          getAvailableWarehouses().catch(() => []),
          getAvailableDrivers().catch(() => [])
        ]);
        this.warehouses = whRes || [];
        this.drivers = drvRes || [];
        // 默认选第一个仓库
        if (this.warehouses.length > 0) {
          const def = this.warehouses.find(w => w.isDefault) || this.warehouses[0];
          this.createTaskForm.warehouseId = def.id;
        }
      } catch (e) {
        this.$message.warning('加载仓库/配送员列表失败');
      }
    },
    async submitCreateTask() {
      if (!this.createTaskForm.warehouseId || !this.createTaskForm.driverId) {
        this.$message.warning('请选择仓库和配送员');
        return;
      }
      this.creating = true;
      try {
        await createAfterSalesDeliveryTask(this.detail.id, this.createTaskForm);
        this.$message.success('配送任务已创建');
        this.createTaskVisible = false;
        // 刷新详情
        await this.loadDetail();
      } catch (e) {
        this.$message.error('创建失败: ' + (e.response?.data?.message || e.message));
      } finally { this.creating = false; }
    },
    viewTask() {
      // 跳转到配送员任务详情页（如果有）
      if (this.deliveryTask && this.deliveryTask.id) {
        this.$message.info('配送任务 #' + this.deliveryTask.taskNo + ' ' + this.deliveryTaskStatusText(this.deliveryTask.status));
      }
    }
  }
};
</script>

<style scoped>
.page-header { background: linear-gradient(135deg, #1d3557, #457b9d); color: #fff; padding: calc(16px + env(safe-area-inset-top, 0px)); }
.back-btn { font-size: 12px; opacity: 0.8; cursor: pointer; margin-bottom: 4px; }
.back-btn:hover { opacity: 1; }
.page-header h1 { font-size: 17px; }
.page-header .sub { font-size: 12px; opacity: 0.8; }

.content { max-width: 600px; margin: 0 auto; padding-bottom: 20px; background: #f5f5f5; min-height: calc(100vh - 80px); }

.module { margin: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
.module-header { display: flex; align-items: center; padding: 12px 12px 8px; gap: 6px; border-bottom: 1px solid #f0f0f0; }
.module-header .icon { font-size: 16px; }
.module-header .title { font-size: 14px; font-weight: 600; flex: 1; }
.module-body { padding: 12px; }

.row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 13px; }
.row .label { color: #999; flex-shrink: 0; }
.row .value { font-weight: 500; text-align: right; }
.row + .row { border-top: 1px dashed #f0f0f0; }
.row .value.mono { font-family: monospace; font-size: 12px; }
.row .value.amount { color: #ff4d4f; font-size: 15px; font-weight: 700; }

.evidence-grid { display: flex; gap: 8px; flex-wrap: wrap; }
.evidence-img { width: 80px; height: 80px; border-radius: 6px; }

/* 进度条 */
.progress-bar { display: flex; align-items: center; overflow-x: auto; padding: 8px 0; }
.progress-step { display: flex; flex-direction: column; align-items: center; min-width: 44px; flex: 1; }
.progress-dot { width: 28px; height: 28px; border-radius: 50%; background: #e8e8e8; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #999; }
.progress-dot.done { background: #52c41a; color: #fff; }
.progress-dot.active { background: #1890ff; color: #fff; }
.progress-label { font-size: 10px; color: #999; margin-top: 4px; text-align: center; }
.progress-label.active { color: #1890ff; }

.log-item { display: flex; gap: 8px; padding: 8px 0; border-bottom: 1px solid #f5f5f5; }
.log-item:last-child { border-bottom: none; }
.log-dot { width: 6px; height: 6px; border-radius: 50%; background: #457b9d; margin-top: 5px; flex-shrink: 0; }
.log-content { flex: 1; }
.log-title { font-size: 12px; font-weight: 500; }
.log-note { font-size: 11px; color: #666; margin-top: 1px; }
.log-time { font-size: 10px; color: #bbb; margin-top: 2px; }
.empty-state { text-align: center; padding: 24px 0; color: #999; }
.empty-icon { font-size: 32px; margin-bottom: 8px; }
.empty-text { font-size: 13px; }

.product-tag {
  display: inline-block;
  background: #f0f5ff;
  color: #457b9d;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
  margin: 2px 4px 2px 0;
}
</style>
